export default __webpack_public_path__ + "static/media/catering.f879d381.jpg";